// extracted by mini-css-extract-plugin
export default {"container":"Z9X7u","error":"_6omVK","center":"iE2P4","content":"bStFq","close":"BRqtF","mobile":"bOh3q","hidden":"D+hmS"};